import { useState, useEffect } from "react";
import { jwtFetch } from "./utils/apiClient";
import { format, subMonths, startOfDay, endOfDay } from "date-fns";
import { config, priceFormat } from "./Components/Config";
import Select from "react-select";
import { Modal, Dropdown } from "react-bootstrap";
import Menu from "./Components/Menu";
import Header from "./Components/Header";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { GoogleGenAI } from "@google/genai";

const Report = () => {
  const [quotationReport, setQuotationReport] = useState([]);
  const [iouReport, setIouReport] = useState([]);
  const [opportunityReport, setOpportunityReport] = useState([]);
  const [leadReport, setLeadReport] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [filterReportType, setFilterReportType] = useState([]);
  const [filterQuotationStatus, setFilterQuotationStatus] = useState([]);
  const [filterIouStatus, setFilterIouStatus] = useState([]);
  const [filterLeadStatus, setFilterLeadStatus] = useState([]);
  const [filterOpportunityStatus, setFilterOpportunityStatus] = useState([]);
  const [filterSalesName, setFilterSalesName] = useState([]);
  const [filterCompanyName, setFilterCompanyName] = useState([]);
  const [filterCreatedDateStart, setFilterCreatedDateStart] = useState(format(subMonths(new Date(), 1), 'yyyy-MM-dd'));
  const [filterCreatedDateEnd, setFilterCreatedDateEnd] = useState(format(new Date(), 'yyyy-MM-dd'));
  const [promptModal, setPromptModal] = useState(false);
  const [promptLoading, setPromptLoading] = useState(false);
  const [promptMessage, setPromptMessage] = useState('');
  const [promptResponse, setPromptResponse] = useState('');
  const [isGenerated, setIsGenerated] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const crmUser = JSON.parse(localStorage.getItem('crmUser'));

  const isSalesReport = filterReportType && filterReportType.value === 'Sales';
  const isInvoiceReport = filterReportType && filterReportType.value === 'Invoice';
  const isOpportunityReport = filterReportType && filterReportType.value === 'Opportunity';
  const isLeadReport = filterReportType && filterReportType.value === 'Lead';
  let grossSales = 0;
  let grossProfit = 0;
  let totalQuotations = 0;
  let totalSoldItems = 0;
  let wonQuotations = 0;
  let profitPercentSum = 0;
  let quotationWinRate = 0;
  let avgProfitPercent = 0;
  let totalOpportunities = 0;
  let totalWonOpportunities = 0;
  let totalEstimatedRevenue = 0;
  let totalEstimatedProfit = 0;
  let totalQuotationRevenue = 0;
  let totalQuotationProfit = 0;
  let totalLeads = 0;
  let totalLeadsWithOpportunities = 0;
  let totalQualifiedLeads = 0;
  let totalWonLeads = 0;
  let totalLeadQuotationRevenue = 0;
  let totalLeadQuotationProfit = 0;

  if ((isSalesReport || isInvoiceReport || isOpportunityReport) && tableData && tableData.length > 0) {
    if (isSalesReport || isInvoiceReport) {
      if (isSalesReport) {
        totalSoldItems = tableData.length;
      }
      for (let i = 0; i < tableData.length; i++) {
        const row = tableData[i];
        const prevRow = i > 0 ? tableData[i - 1] : null;
        const isFirstForQuotation = !prevRow || row.quotation_code !== prevRow.quotation_code;
        if (isInvoiceReport && row.iou_status === 'Paid in Full') {
          totalSoldItems += 1;
        }
        if (isFirstForQuotation) {
          totalQuotations += 1;
          if (row.status === 'Won') {
            wonQuotations += 1;
            grossSales += Number(row.quotation_grand_total) || 0;
            grossProfit += Number(row.quotation_margin) || 0;
            profitPercentSum += Number(row.quotation_margin_percentage) || 0;
          }
        }
      }
      if (totalQuotations > 0) {
        quotationWinRate = (wonQuotations / totalQuotations) * 100;
      }
      if (wonQuotations > 0) {
        avgProfitPercent = profitPercentSum / wonQuotations;
      }
    }
    if (isOpportunityReport) {
      totalOpportunities = tableData.length;
      for (let i = 0; i < tableData.length; i++) {
        const row = tableData[i];
        if (row.opportunity_status === 'Won') {
          totalWonOpportunities += 1;
        }
        totalEstimatedRevenue += Number(row.opportunity_expected_revenue) || 0;
        totalEstimatedProfit += Number(row.opportunity_expected_profit) || 0;
        totalQuotationRevenue += Number(row.quotation_total) || 0;
        totalQuotationProfit += Number(row.quotation_margin_price) || 0;
      }
    }
  }

  if (isLeadReport && tableData && tableData.length > 0) {
    totalLeads = tableData.length;
    for (let i = 0; i < tableData.length; i++) {
      const row = tableData[i];
      if (row.opportunity_statuses && row.opportunity_statuses.toString().trim() !== '') {
        totalLeadsWithOpportunities += 1;
      }
      if (row.lead_status === 'Won' || row.lead_status === 'Sales Qualified Lead' || row.lead_status === 'Sent to Sales' || row.lead_status === 'Marketing Qualified Lead') {
        totalQualifiedLeads += 1;
      }
      if (row.won_date) {
        totalWonLeads += 1;
      }
      totalLeadQuotationRevenue += Number(row.quotation_total) || 0;
      totalLeadQuotationProfit += Number(row.quotation_margin_price) || 0;
    }
  }

  const optionsReportType = [
    { value: 'Sales', label: 'Sales' },
    { value: 'Invoice', label: 'Invoice' },
    { value: 'Opportunity', label: 'Opportunity' },
    { value: 'Lead', label: 'Lead' }
  ];
  const filteredOptionsReportType = optionsReportType.filter(option => {
    if ((((crmUser.user_department === 'Sales' || crmUser.user_department === 'Marketing') && (crmUser.user_role_division !== 'Head' && crmUser.user_role_division !== 'Manager'))) &&
      (option.value === 'Sales' || option.value === 'Invoice')) {
      return false;
    }
    if ((crmUser.user_department === 'Sales Admin') &&
      (option.value === 'Opportunity' || option.value === 'Lead')) {
      return false;
    }
    return true;
  });
  const optionsQuotationStatus = [
    { value: 'Draft', label: 'Draft' },
    { value: 'Pending Approval', label: 'Pending Approval' },
    { value: 'Open', label: 'Open' },
    { value: 'Won', label: 'Won' },
    { value: 'Expired', label: 'Expired' },
    { value: 'Rejected', label: 'Rejected' },
    { value: 'Cancelled', label: 'Cancelled' },
    { value: 'Lost', label: 'Lost' }
  ];
  const optionsIouStatus = [
    { value: 'New', label: 'New' },
    { value: 'In Progress', label: 'In Progress' },
    { value: 'Notification Sent', label: 'Notification Sent' },
    { value: 'Invoice Issued', label: 'Invoice Issued' },
    { value: 'Stopped', label: 'Stopped' },
    { value: 'Paid in Full', label: 'Paid in Full' }
  ];
  const optionsOpportunityStatus = [
    { value: 'Open', label: 'Open' },
    { value: 'Opportunity', label: 'Opportunity' },
    { value: 'Won', label: 'Won' },
    { value: 'On Hold', label: 'On Hold' },
    { value: 'Lost', label: 'Lost' }
  ];
  const optionsLeadStatus = [
    { value: 'New', label: 'New' },
    { value: 'Marketing Qualified Lead', label: 'Marketing Qualified Lead' },
    { value: 'Sent to Sales', label: 'Sent to Sales' },
    { value: 'Sales Qualified Lead', label: 'Sales Qualified Lead' },
    { value: 'Won', label: 'Won' },
    { value: 'Lost', label: 'Lost' },
    { value: 'Nurture', label: 'Nurture' }
  ];
  const [optionsSalesName, setOptionsSalesName] = useState([]);
  const [optionsCompanyName, setOptionsCompanyName] = useState([]);

  useEffect(() => {
    getUsers();
    getCompanies();
  }, []);

  useEffect(() => {
    if (!filterReportType) return;
    const controller = new AbortController();
    if (filterReportType.value === 'Sales') {
      getQuotationReport(controller.signal);
    } else if (filterReportType.value === 'Invoice') {
      getIouReport(controller.signal);
    } else if (filterReportType.value === 'Opportunity') {
      getOpportunityReport(controller.signal);
    } else if (filterReportType.value === 'Lead') {
      getLeadReport(controller.signal);
    }
    return () => controller.abort();
  }, [filterReportType, filterCreatedDateStart, filterCreatedDateEnd]);

  useEffect(() => {
    setFilterSalesName([]);
    setFilterCompanyName([]);
  }, [filterReportType]);

  const getQuotationReport = async (signal) => {
    try {
      setIsLoading(true);
      const requestQuotationReport = { dateStart: filterCreatedDateStart, dateEnd: filterCreatedDateEnd };
      const fetchQuotationReport = await jwtFetch(config.ENDPOINT + 'get/quotation_report', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestQuotationReport),
        signal,
      });
      const responseGetQuotationReport = await fetchQuotationReport.json();
      if (responseGetQuotationReport.status === 200) {
        setQuotationReport(responseGetQuotationReport.data);
      } else {
        alert(responseGetQuotationReport.message);
      }
      setIsLoading(false);
    } catch (error) {
      if (error.name === 'AbortError') return;
      console.error('Error in getQuotationReport:', error);
      alert('An error occurred: ' + (error.message || error));
      setIsLoading(false);
    }
  };

  const getIouReport = async (signal) => {
    try {
      setIsLoading(true);
      const requestIouReport = { dateStart: filterCreatedDateStart, dateEnd: filterCreatedDateEnd };
      const fetchIouReport = await jwtFetch(config.ENDPOINT + 'get/iou_report', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestIouReport),
        signal,
      });
      const responseGetIouReport = await fetchIouReport.json();
      if (responseGetIouReport.status === 200) {
        setIouReport(responseGetIouReport.data);
      } else {
        alert(responseGetIouReport.message);
      }
      setIsLoading(false);
    } catch (error) {
      if (error.name === 'AbortError') return;
      console.error('Error in getIouReport:', error);
      alert('An error occurred: ' + (error.message || error));
      setIsLoading(false);
    }
  };

  const getOpportunityReport = async (signal) => {
    try {
      setIsLoading(true);
      const requestOpportunityReport = { dateStart: filterCreatedDateStart, dateEnd: filterCreatedDateEnd };
      const fetchOpportunityReport = await jwtFetch(config.ENDPOINT + 'get/opportunity_report', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestOpportunityReport),
        signal,
      });
      const responseGetOpportunityReport = await fetchOpportunityReport.json();
      if (responseGetOpportunityReport.status === 200) {
        setOpportunityReport(responseGetOpportunityReport.data);
      } else {
        alert(responseGetOpportunityReport.message);
      }
      setIsLoading(false);
    } catch (error) {
      if (error.name === 'AbortError') return;
      console.error('Error in getOpportunityReport:', error);
      alert('An error occurred: ' + (error.message || error));
      setIsLoading(false);
    }
  };

  const getLeadReport = async (signal) => {
    try {
      setIsLoading(true);
      const requestLeadReport = { dateStart: filterCreatedDateStart, dateEnd: filterCreatedDateEnd };
      const fetchLeadReport = await jwtFetch(config.ENDPOINT + 'get/lead_report', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestLeadReport),
        signal,
      });
      const responseGetLeadReport = await fetchLeadReport.json();
      if (responseGetLeadReport.status === 200) {
        setLeadReport(responseGetLeadReport.data);
      } else {
        alert(responseGetLeadReport.message);
      }
      setIsLoading(false);
    } catch (error) {
      if (error.name === 'AbortError') return;
      console.error('Error in getLeadReport:', error);
      alert('An error occurred: ' + (error.message || error));
      setIsLoading(false);
    }
  };

  const getUsers = async () => {
    try {
      setIsLoading(true);
      const requestUsers = {};
      const fetchUsers = await jwtFetch(config.ENDPOINT + 'get/user', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestUsers)
      });
      const responseGetUsers = await fetchUsers.json();
      if (responseGetUsers.status === 200) {
        const arrayGetUsers = responseGetUsers.data
          .sort((a, b) => (a.full_name || '').localeCompare(b.full_name || ''))
          .map(user => ({
            value: user.full_name,
            label: user.full_name,
            status: user.user_status,
          }));
        setOptionsSalesName(arrayGetUsers);
        setIsLoading(false);
      } else {
        alert(responseGetUsers.message);
      }
    } catch (error) {
      console.error('Error in getUsers:', error);
      alert('An error occurred: ' + (error.message || error));
      setIsLoading(false);
    }
  };

  const getCompanies = async () => {
    try {
      setIsLoading(true);
      const requestCompanies = {};
      const fetchCompanies = await jwtFetch(config.ENDPOINT + 'get/company', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestCompanies)
      });
      const responseGetCompanies = await fetchCompanies.json();
      if (responseGetCompanies.status === 200) {
        const arrayGetCompanies = responseGetCompanies.data
          .sort((a, b) => (a.company_billing_name || '').localeCompare(b.company_billing_name || ''))
          .map(company => ({
            value: company.id_company,
            label: company.company_billing_name,
            status: company.company_status,
          }));
        setOptionsCompanyName(arrayGetCompanies);
        setIsLoading(false);
      } else {
        alert(responseGetCompanies.message);
      }
    } catch (error) {
      console.error('Error in getCompanies:', error);
      alert('An error occurred: ' + (error.message || error));
      setIsLoading(false);
    }
  };

  const generateReport = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    const startDate = filterCreatedDateStart ? startOfDay(new Date(filterCreatedDateStart)) : null;
    const endDate = filterCreatedDateEnd ? endOfDay(new Date(filterCreatedDateEnd)) : null;
    let filteredData = [];
    if (filterReportType.value === 'Sales') {
      filteredData = [...quotationReport];
      if (startDate) {
        filteredData = filteredData.filter(q => new Date(q.created_date) >= startDate);
      }
      if (endDate) {
        filteredData = filteredData.filter(q => new Date(q.created_date) <= endDate);
      }
      if (filterQuotationStatus.length > 0) {
        const statusValues = filterQuotationStatus.map(s => s.value);
        filteredData = filteredData.filter(q => statusValues.includes(q.status));
      }
      if (filterSalesName.length > 0) {
        const salesNameValues = filterSalesName.map(s => s.label);
        filteredData = filteredData.filter(q => salesNameValues.includes(q.sales_name));
      }
      if (filterCompanyName.length > 0) {
        const companyNameValues = filterCompanyName.map(s => s.label);
        filteredData = filteredData.filter(q => companyNameValues.includes(q.company_name));
      }
    } else if (filterReportType.value === 'Invoice') {
      filteredData = [...iouReport];
      if (startDate) {
        filteredData = filteredData.filter(q => new Date(q.created_date) >= startDate);
      }
      if (endDate) {
        filteredData = filteredData.filter(q => new Date(q.created_date) <= endDate);
      }
      if (filterIouStatus.length > 0) {
        const statusValues = filterIouStatus.map(s => s.value);
        filteredData = filteredData.filter(q => statusValues.includes(q.iou_status));
      }
      if (filterSalesName.length > 0) {
        const salesNameValues = filterSalesName.map(s => s.label);
        filteredData = filteredData.filter(q => salesNameValues.includes(q.sales_name));
      }
      if (filterCompanyName.length > 0) {
        const companyNameValues = filterCompanyName.map(s => s.label);
        filteredData = filteredData.filter(q => companyNameValues.includes(q.company_name));
      }
    } else if (filterReportType.value === 'Opportunity') {
      filteredData = [...opportunityReport];
      if (startDate) {
        filteredData = filteredData.filter(q => new Date(q.created_on) >= startDate);
      }
      if (endDate) {
        filteredData = filteredData.filter(q => new Date(q.created_on) <= endDate);
      }
      if (filterOpportunityStatus.length > 0) {
        const statusValues = filterOpportunityStatus.map(s => s.value);
        filteredData = filteredData.filter(q => statusValues.includes(q.opportunity_status));
      }
      if (filterSalesName.length > 0) {
        const salesNameValues = filterSalesName.map(s => s.label);
        filteredData = filteredData.filter(q => salesNameValues.includes(q.sales_name));
      }
      if (filterCompanyName.length > 0) {
        const companyNameValues = filterCompanyName.map(s => s.label);
        filteredData = filteredData.filter(q => companyNameValues.includes(q.company_name));
      }
    } else if (filterReportType.value === 'Lead') {
      filteredData = [...leadReport];
      if (startDate) {
        filteredData = filteredData.filter(q => new Date(q.created_on) >= startDate);
      }
      if (endDate) {
        filteredData = filteredData.filter(q => new Date(q.created_on) <= endDate);
      }
      if (filterLeadStatus.length > 0) {
        const statusValues = filterLeadStatus.map(s => s.value);
        filteredData = filteredData.filter(q => statusValues.includes(q.lead_status));
      }
      if (filterSalesName.length > 0) {
        const salesNameValues = filterSalesName.map(s => s.label);
        filteredData = filteredData.filter(q => salesNameValues.includes(q.sales_name));
      }
      if (filterCompanyName.length > 0) {
        const companyNameValues = filterCompanyName.map(s => s.label);
        filteredData = filteredData.filter(q => companyNameValues.includes(q.company_name));
      }
    }

    setTableData(filteredData);
    setIsGenerated(true);
    setIsLoading(false);
  }

  const sendToAi = async (data, action, prompt) => {
    try {
      const response = await jwtFetch(config.ENDPOINT + 'report', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          tableData: data,
          userKeyId: crmUser.user_keyid,
          action: action,
          prompt: prompt,
        }),
      });
      const result = await response.json();
      return result;
    } catch (error) {
      console.error('Error uploading report:', error);
    }
  };

  const sendPrompt = async (e) => {
    e.preventDefault();
    setPromptLoading(true);
    const promptResponse = await sendToAi(tableData, 'prompt', promptMessage);
    setPromptResponse(promptResponse);
    setPromptLoading(false);
  }

  const clearPrompt = () => {
    setPromptMessage('');
    setPromptResponse('');
  }

  const closePrompt = () => {
    setPromptModal(false);
    clearPrompt();
  }

  const printPrompt = () => {
    const content = document.getElementById('printable-prompt').innerHTML;
    const printWindow = window.open('', 'Print', 'height=600,width=800');
    printWindow.document.write('<html><head><title>Print</title>');
    printWindow.document.write('<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/css/bootstrap.min.css">');
    printWindow.document.write('<style>body { padding: 1rem; }</style>');
    printWindow.document.write('</head><body>');
    printWindow.document.write(content);
    printWindow.document.write('</body></html>');
    printWindow.document.close();
    printWindow.focus();
    setTimeout(function () {
      printWindow.print();
    }, 1000);
  }

  const getSalesExportData = () => {
    const description = [
      "Filtered date: " + format(new Date(filterCreatedDateStart), 'dd MMM yyyy') + " - " + format(new Date(filterCreatedDateEnd), 'dd MMM yyyy'),
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "Format to number",
      "",
      "",
      "",
      "",
      "",
      "",
      "Format to number",
      "Format to number",
      "",
      "Format to number",
      "Format to number",
      "",
      "Format to number",
      "Format to number",
      "Format to number",
      "Format to number",
      "Format to percentage",
      "Format to number",
      "Format to number",
      "Format to percentage",
      "Format to number",
      "Format to number",
      "Format to percentage",
      "Format to number",
      "Format to number",
      "Format to percentage\nAlready calculated from total profit/total revenue on QT level",
      "",
      "",
      "",
      "Format to number",
      "Format to number",
      "Format to number",
      "Format to number",
      "Format to number",
      "Format to number",
      "Format to number",
      "",
      "",
      "",
    ];
    const headers = [
      "#",
      "QT_Number",
      "Status",
      "Is_Invoicing_Only?",
      "Company_Group",
      "Subsidiary",
      "Salesperson",
      "Created_Date",
      "Effective_Date",
      "Expiry_Date",
      "Won_Date",
      "SO_Number",
      "SO_Status",
      "INVREQ_Number",
      "INVREQ_Status",
      "Invoice_Number",
      "QT_Currency",
      "FX_Base_Currency",
      "FX_Rate_to_IDR",
      "FX_Type",
      "Order_Type",
      "Is_Upgrade?",
      "Product_Type",
      "Product_Tagging",
      "Domain_Provisioning",
      "SKU",
      "Quantity",
      "Contract_Length_Months",
      "Cost_Currency",
      "Cost_Unit_Original",
      "Cost_Unit_IDR",
      "Sell_Currency",
      "Sell_Unit_Original",
      "Sell_Unit_IDR",
      "Item_Subtotal_IDR",
      "Item_Discount_Amount_IDR",
      "Item_Discount_Percent",
      "Item_GrandTotal_IDR",
      "Item_Margin_IDR",
      "Item_Margin_Percent",
      "QT_Subtotal_IDR",
      "QT_Discount_Amount_IDR",
      "QT_Discount_Percent",
      "QT_GrandTotal_IDR",
      "QT_Profit_IDR",
      "QT_Profit_Percent",
      "Payment_Type",
      "Period_Start_Date",
      "Period_End_Date",
      "Helper_QT_Subtotal_IDR",
      "Helper_QT_Discount_IDR",
      "Helper_QT_GrandTotal_IDR",
      "Helper_QT_Profit_IDR",
      "Helper_Cancelled_IDR",
      "Helper_Actual_IDR",
      "Helper_QT_Count",
      "Renewal_Flag",
      "Year",
      "Month",
    ];
    const data = tableData.map((rowData, r) => [
      r + 1,
      rowData.quotation_code,
      rowData.status,
      rowData.is_invoicing_only ? 'Yes' : 'No',
      rowData.company_name,
      rowData.subcompany_name,
      rowData.sales_name,
      format(rowData.created_date, 'd MMM yyyy'),
      format(rowData.effective_date, 'd MMM yyyy'),
      format(rowData.expiry_date, 'd MMM yyyy'),
      rowData.won_date ? format(rowData.won_date, 'd MMM yyyy') : '',
      rowData.so_code,
      rowData.so_status,
      rowData.iou_code_first,
      rowData.iou_status_first,
      rowData.invoice_number_first,
      rowData.currency,
      rowData.original_currency,
      Number(rowData.exchange_rate),
      rowData.exchange_type,
      rowData.order_type,
      rowData.is_upgrade ? 'Yes' : 'No',
      rowData.product_type,
      rowData.product_tagging,
      rowData.product_domain,
      rowData.sku,
      rowData.quantity,
      rowData.period,
      rowData.original_currency,
      Number(rowData.original_cost_price),
      Number(rowData.cost_price),
      rowData.original_currency,
      Number(rowData.original_selling_price),
      Number(rowData.selling_price),
      Number(rowData.item_subtotal),
      Number(rowData.item_discount),
      Number(rowData.item_discount_percentage) / 100,
      Number(rowData.item_grand_total),
      Number(rowData.item_margin),
      Number(rowData.item_margin_percentage) / 100,
      Number(rowData.quotation_subtotal),
      Number(rowData.quotation_discount),
      Number(rowData.quotation_discount_percentage) / 100,
      Number(rowData.quotation_grand_total),
      Number(rowData.quotation_margin),
      Number(rowData.quotation_margin_percentage) / 100,
      rowData.payment_type,
      rowData.iou_start_date ? format(rowData.iou_start_date, 'd MMM yyyy') : (rowData.start_date ? format(rowData.start_date, 'd MMM yyyy') : ''),
      rowData.iou_end_date ? format(rowData.iou_end_date, 'd MMM yyyy') : (rowData.end_date ? format(rowData.end_date, 'd MMM yyyy') : ''),
      r === 0 || rowData.quotation_code !== tableData[r - 1].quotation_code ? Number(rowData.quotation_subtotal) : '',
      r === 0 || rowData.quotation_code !== tableData[r - 1].quotation_code ? Number(rowData.quotation_discount) : '',
      r === 0 || rowData.quotation_code !== tableData[r - 1].quotation_code ? Number(rowData.quotation_grand_total) : '',
      r === 0 || rowData.quotation_code !== tableData[r - 1].quotation_code ? Number(rowData.quotation_margin) : '',
      r === 0 || rowData.quotation_code !== tableData[r - 1].quotation_code ? Number(rowData.iou_canceled) : '',
      r === 0 || rowData.quotation_code !== tableData[r - 1].quotation_code ? Number(rowData.iou_total) : '',
      r === 0 || rowData.quotation_code !== tableData[r - 1].quotation_code ? 1 : 0,
      rowData.order_type === 'Renewal' ? 1 : 0,
      rowData.quotation_year,
      rowData.quotation_year_month,
    ]);

    return { description, headers, data };
  }

  const generateSalesXls = () => {
    const { description, headers, data } = getSalesExportData();

    const worksheet = XLSX.utils.aoa_to_sheet([description, headers, ...data]);

    const columnWidths = headers.map((_, colIndex) => ({
      wch: Math.max(
        headers[colIndex].length,
        ...data.map(row => (row[colIndex] ? row[colIndex].toString().split('\n')[0].length : 0))
      )
    }));
    worksheet['!cols'] = columnWidths;

    const rowHeights = data.map(row => {
      const maxLines = row.reduce((max, cell) => {
        const lines = cell ? cell.toString().split('\n').length : 1;
        return Math.max(max, lines);
      }, 1);
      return { hpt: maxLines * 15 };
    });
    worksheet['!rows'] = [{ hpt: 20 }, ...rowHeights];

    const range = XLSX.utils.decode_range(worksheet['!ref']);
    for (let R = range.s.r; R <= range.e.r; ++R) {
      for (let C = range.s.c; C <= range.e.c; ++C) {
        const cell_address = { c: C, r: R };
        const cell_ref = XLSX.utils.encode_cell(cell_address);
        if (worksheet[cell_ref]) {
          if (!worksheet[cell_ref].s) worksheet[cell_ref].s = {};

          if (R === 0) {
            if (!worksheet[cell_ref].s.font) worksheet[cell_ref].s.font = {};
            worksheet[cell_ref].s.font.bold = true;
          }

          if (C >= 10 && C <= 22) {
            if (!worksheet[cell_ref].s.alignment) worksheet[cell_ref].s.alignment = {};
            worksheet[cell_ref].s.alignment.wrapText = true;
          }

          if (R > 0 && (C === 20 || C === 26)) {
            if (!worksheet[cell_ref].s.font) worksheet[cell_ref].s.font = {};
            worksheet[cell_ref].s.font.bold = true;
          }
        }
      }
    }

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sales Report");

    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
    saveAs(blob, "Sales Report - " + format(new Date(), 'dd MMM yyyy') + ".xlsx");
  }

  const generateSalesSheet = async () => {
    const { description, headers, data } = getSalesExportData();
    const dataSheet = [description, headers, ...data];

    try {
      const response = await jwtFetch(config.ENDPOINT + 'export/report', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          userKeyId: crmUser.user_keyid,
          userEmail: crmUser.email_address,
          data: dataSheet,
          type: 'Sales',
        }),
      });
      const result = await response.json();
      window.open(result.data.url, '_blank');
    } catch (error) {
      console.error('Error uploading report:', error);
    }
  }

  const getInvoiceExportData = () => {
    const description = [
      "Filtered date: " + format(new Date(filterCreatedDateStart), 'dd MMM yyyy') + " - " + format(new Date(filterCreatedDateEnd), 'dd MMM yyyy'),
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "Format to number",
      "",
      "Format to number",
      "Format to number",
      "Format to percentage",
      "Format to number",
      "Format to number",
      "Format to percentage",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "Format to number",
      "",
      "",
      "",
      "Format to number",
      "Format to number",
      "Format to number",
      "Format to number",
      "Format to number",
      "",
      "",
      "",
    ];
    const headers = [
      "#",
      "QT_Number",
      "Status",
      "Is_Invoicing_Only?",
      "Company_Group",
      "Subsidiary",
      "Salesperson",
      "Created_Date",
      "Effective_Date",
      "Expiry_Date",
      "Won_Date",
      "QT_Currency",
      "FX_Base_Currency",
      "FX_Rate_to_IDR",
      "FX_Type",
      "QT_Subtotal_IDR",
      "QT_Discount_Amount_IDR",
      "QT_Discount_Percent",
      "QT_GrandTotal_IDR",
      "QT_Profit_IDR",
      "QT_Profit_Percent",
      "Payment_Type",
      "Period_Start_Date",
      "Period_End_Date",
      "Sales_Order_Number",
      "Sales_Order_Status",
      "Schedule_Number",
      "Schedule_Start_Date",
      "Schedule_End_Date",
      "Invoice_Request_Amount_IDR",
      "Invoice_Request_Status",
      "Invoice_Request_Code",
      "Invoice_Number",
      "Invoice_Amount_IDR",
      "Helper_QT_Subtotal_IDR",
      "Helper_QT_Discount_IDR",
      "Helper_QT_GrandTotal_IDR",
      "Helper_QT_Profit_IDR",
      "Helper_QT_Count",
      "Year",
      "Month",
    ];
    const data = tableData.map((rowData, r) => [
      r + 1,
      rowData.quotation_code,
      rowData.status,
      rowData.is_invoicing_only ? 'Yes' : 'No',
      rowData.company_name,
      rowData.subcompany_name,
      rowData.sales_name,
      format(rowData.created_date, 'd MMM yyyy'),
      format(rowData.effective_date, 'd MMM yyyy'),
      format(rowData.expiry_date, 'd MMM yyyy'),
      rowData.won_date ? format(rowData.won_date, 'd MMM yyyy') : '',
      rowData.currency,
      rowData.original_currency,
      Number(rowData.exchange_rate),
      rowData.exchange_type,
      Number(rowData.quotation_subtotal),
      Number(rowData.quotation_discount),
      Number(rowData.quotation_discount_percentage) / 100,
      Number(rowData.quotation_grand_total),
      Number(rowData.quotation_margin),
      Number(rowData.quotation_margin_percentage) / 100,
      rowData.payment_type,
      rowData.iou_start_date ? format(rowData.iou_start_date, 'd MMM yyyy') : (rowData.start_date ? format(rowData.start_date, 'd MMM yyyy') : ''),
      rowData.iou_end_date ? format(rowData.iou_end_date, 'd MMM yyyy') : (rowData.end_date ? format(rowData.end_date, 'd MMM yyyy') : ''),
      rowData.so_code,
      rowData.so_status,
      rowData.iou_schedule,
      rowData.iou_start_date ? format(rowData.iou_start_date, 'd MMM yyyy') : '',
      rowData.iou_end_date ? format(rowData.iou_end_date, 'd MMM yyyy') : '',
      rowData.iou_grand_total ? Number(rowData.iou_grand_total) : '',
      rowData.iou_status,
      rowData.iou_code,
      rowData.invoice_number,
      rowData.invoice_amount ? Number(rowData.invoice_amount) : '',
      r === 0 || rowData.quotation_code !== tableData[r - 1].quotation_code ? Number(rowData.quotation_subtotal) : '',
      r === 0 || rowData.quotation_code !== tableData[r - 1].quotation_code ? Number(rowData.quotation_discount) : '',
      r === 0 || rowData.quotation_code !== tableData[r - 1].quotation_code ? Number(rowData.quotation_grand_total) : '',
      r === 0 || rowData.quotation_code !== tableData[r - 1].quotation_code ? Number(rowData.quotation_margin) : '',
      r === 0 || rowData.quotation_code !== tableData[r - 1].quotation_code ? 1 : 0,
      rowData.quotation_year,
      rowData.quotation_year_month,
    ]);
    return { description, headers, data };
  }

  const getOpportunityExportData = () => {
    const description = [
      "Filtered date: " + format(new Date(filterCreatedDateStart), 'dd MMM yyyy') + " - " + format(new Date(filterCreatedDateEnd), 'dd MMM yyyy'),
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "Format to number",
      "Format to number",
      "Format to number",
      "Format to number",
      "Format to number",
    ];
    const headers = [
      "#",
      "Opportunity_Number",
      "Status",
      "Company_Group",
      "Subsidiary",
      "Salesperson",
      "Created_Date",
      "Source",
      "Product",
      "Deal_Type",
      "Months",
      "Expected_Closing_Date",
      "Won_Date",
      "Open_for_Days",
      "Estimated_Revenue",
      "Estimated_Profit",
      "Quotation_Revenue",
      "Quotation_Profit",
    ];
    const data = tableData.map((rowData, r) => [
      r + 1,
      rowData.opportunity_code,
      rowData.opportunity_status,
      rowData.company_name,
      rowData.subcompany_name,
      rowData.sales_name,
      format(rowData.created_on, 'd MMM yyyy'),
      rowData.opportunity_source,
      rowData.opportunity_product_line,
      rowData.opportunity_deal_type,
      rowData.opportunity_product_months,
      rowData.opportunity_expected_closed ? format(rowData.opportunity_expected_closed, 'd MMM yyyy') : '',
      rowData.won_date ? format(rowData.won_date, 'd MMM yyyy') : '',
      Number(rowData.open_for),
      Number(rowData.opportunity_expected_revenue),
      Number(rowData.opportunity_expected_profit),
      Number(rowData.quotation_total),
      Number(rowData.quotation_margin_price),
    ]);
    return { description, headers, data };
  }

  const getLeadExportData = () => {
    const description = [
      "Filtered date: " + format(new Date(filterCreatedDateStart), 'dd MMM yyyy') + " - " + format(new Date(filterCreatedDateEnd), 'dd MMM yyyy'),
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "Format to number",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "Format to number",
      "Format to number",
    ];
    const headers = [
      "#",
      "Lead_Number",
      "Created_Date",
      "Status",
      "Company_Group",
      "Subsidiary",
      "Contact_Person",
      "Email_address",
      "Phone_Number",
      "Position",
      "Category",
      "Product",
      "DR_Number",
      "Budget",
      "Authority",
      "Need",
      "Timeline",
      "Source",
      "Channel",
      "Follow_Up",
      "Marketingperson",
      "Assigned_to",
      "Opportunity_Statuses",
      "Quotation_Statuses",
      "Won_Date",
      "Quotation_Revenue",
      "Quotation_Profit",
    ];
    const data = tableData.map((rowData, r) => [
      r + 1,
      rowData.lead_code,
      format(rowData.created_on, 'd MMM yyyy'),
      rowData.lead_status,
      rowData.company_name,
      rowData.subcompany_name,
      rowData.contact_name,
      rowData.contact_email,
      rowData.contact_phone,
      rowData.contact_position,
      rowData.lead_category,
      rowData.lead_products,
      rowData.lead_dr_number,
      Number(rowData.bant_budget),
      rowData.bant_authority,
      rowData.bant_need,
      rowData.bant_timeline,
      rowData.source_name,
      rowData.source_channel,
      rowData.source_status,
      rowData.marketing_name,
      rowData.sales_name,
      rowData.opportunity_statuses,
      rowData.quotation_statuses,
      rowData.won_date ? format(rowData.won_date, 'd MMM yyyy') : '',
      Number(rowData.quotation_total),
      Number(rowData.quotation_margin_price),
    ]);
    return { description, headers, data };
  }

  const generateInvoiceXls = () => {
    const { description, headers, data } = getInvoiceExportData();

    const worksheet = XLSX.utils.aoa_to_sheet([description, headers, ...data]);

    const columnWidths = headers.map((_, colIndex) => ({
      wch: Math.max(
        headers[colIndex].length,
        ...data.map(row => (row[colIndex] ? row[colIndex].toString().split('\n')[0].length : 0))
      )
    }));
    worksheet['!cols'] = columnWidths;

    const rowHeights = data.map(row => {
      const maxLines = row.reduce((max, cell) => {
        const lines = cell ? cell.toString().split('\n').length : 1;
        return Math.max(max, lines);
      }, 1);
      return { hpt: maxLines * 15 };
    });
    worksheet['!rows'] = [{ hpt: 20 }, ...rowHeights];

    const range = XLSX.utils.decode_range(worksheet['!ref']);
    for (let R = range.s.r; R <= range.e.r; ++R) {
      for (let C = range.s.c; C <= range.e.c; ++C) {
        const cell_address = { c: C, r: R };
        const cell_ref = XLSX.utils.encode_cell(cell_address);
        if (worksheet[cell_ref]) {
          if (!worksheet[cell_ref].s) worksheet[cell_ref].s = {};

          if (R === 0) {
            if (!worksheet[cell_ref].s.font) worksheet[cell_ref].s.font = {};
            worksheet[cell_ref].s.font.bold = true;
          }

          if (C >= 10 && C <= 22) {
            if (!worksheet[cell_ref].s.alignment) worksheet[cell_ref].s.alignment = {};
            worksheet[cell_ref].s.alignment.wrapText = true;
          }

          if (R > 0 && (C === 20 || C === 26)) {
            if (!worksheet[cell_ref].s.font) worksheet[cell_ref].s.font = {};
            worksheet[cell_ref].s.font.bold = true;
          }
        }
      }
    }

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Invoice Report");

    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
    saveAs(blob, "Invoice Report - " + format(new Date(), 'dd MMM yyyy') + ".xlsx");
  }

  const generateInvoiceSheet = async () => {
    const { description, headers, data } = getInvoiceExportData();
    const dataSheet = [description, headers, ...data];

    try {
      const response = await jwtFetch(config.ENDPOINT + 'export/report', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          userKeyId: crmUser.user_keyid,
          userEmail: crmUser.email_address,
          data: dataSheet,
          type: 'Invoice',
        }),
      });
      const result = await response.json();
      window.open(result.data.url, '_blank');
    } catch (error) {
      console.error('Error uploading report:', error);
    }
  }

  const generateOpportunityXls = () => {
    const { description, headers, data } = getOpportunityExportData();

    const worksheet = XLSX.utils.aoa_to_sheet([description, headers, ...data]);

    const columnWidths = headers.map((_, colIndex) => ({
      wch: Math.max(
        headers[colIndex].length,
        ...data.map(row => (row[colIndex] ? row[colIndex].toString().split('\n')[0].length : 0))
      )
    }));
    worksheet['!cols'] = columnWidths;

    const rowHeights = data.map(row => {
      const maxLines = row.reduce((max, cell) => {
        const lines = cell ? cell.toString().split('\n').length : 1;
        return Math.max(max, lines);
      }, 1);
      return { hpt: maxLines * 15 };
    });
    worksheet['!rows'] = [{ hpt: 20 }, ...rowHeights];

    const range = XLSX.utils.decode_range(worksheet['!ref']);
    for (let R = range.s.r; R <= range.e.r; ++R) {
      for (let C = range.s.c; C <= range.e.c; ++C) {
        const cell_address = { c: C, r: R };
        const cell_ref = XLSX.utils.encode_cell(cell_address);
        if (worksheet[cell_ref]) {
          if (!worksheet[cell_ref].s) worksheet[cell_ref].s = {};

          if (R === 0) {
            if (!worksheet[cell_ref].s.font) worksheet[cell_ref].s.font = {};
            worksheet[cell_ref].s.font.bold = true;
          }

          if (C >= 10 && C <= 18) {
            if (!worksheet[cell_ref].s.alignment) worksheet[cell_ref].s.alignment = {};
            worksheet[cell_ref].s.alignment.wrapText = true;
          }
        }
      }
    }

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Opportunity Report");

    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
    saveAs(blob, "Opportunity Report - " + format(new Date(), 'dd MMM yyyy') + ".xlsx");
  }

  const generateOpportunitySheet = async () => {
    const { description, headers, data } = getOpportunityExportData();
    const dataSheet = [description, headers, ...data];

    try {
      const response = await jwtFetch(config.ENDPOINT + 'export/report', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          userKeyId: crmUser.user_keyid,
          userEmail: crmUser.email_address,
          data: dataSheet,
          type: 'Opportunity',
        }),
      });
      const result = await response.json();
      window.open(result.data.url, '_blank');
    } catch (error) {
      console.error('Error uploading report:', error);
    }
  }

  const generateLeadXls = () => {
    const { description, headers, data } = getLeadExportData();

    const worksheet = XLSX.utils.aoa_to_sheet([description, headers, ...data]);

    const columnWidths = headers.map((_, colIndex) => ({
      wch: Math.max(
        headers[colIndex].length,
        ...data.map(row => (row[colIndex] ? row[colIndex].toString().split('\n')[0].length : 0))
      )
    }));
    worksheet['!cols'] = columnWidths;

    const rowHeights = data.map(row => {
      const maxLines = row.reduce((max, cell) => {
        const lines = cell ? cell.toString().split('\n').length : 1;
        return Math.max(max, lines);
      }, 1);
      return { hpt: maxLines * 15 };
    });
    worksheet['!rows'] = [{ hpt: 20 }, ...rowHeights];

    const range = XLSX.utils.decode_range(worksheet['!ref']);
    for (let R = range.s.r; R <= range.e.r; ++R) {
      for (let C = range.s.c; C <= range.e.c; ++C) {
        const cell_address = { c: C, r: R };
        const cell_ref = XLSX.utils.encode_cell(cell_address);
        if (worksheet[cell_ref]) {
          if (!worksheet[cell_ref].s) worksheet[cell_ref].s = {};

          if (R === 0) {
            if (!worksheet[cell_ref].s.font) worksheet[cell_ref].s.font = {};
            worksheet[cell_ref].s.font.bold = true;
          }

          if (C >= 10 && C <= 22) {
            if (!worksheet[cell_ref].s.alignment) worksheet[cell_ref].s.alignment = {};
            worksheet[cell_ref].s.alignment.wrapText = true;
          }
        }
      }
    }

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Leads Report");

    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
    saveAs(blob, "Leads Report - " + format(new Date(), 'dd MMM yyyy') + ".xlsx");
  }

  const generateLeadSheet = async () => {
    const { description, headers, data } = getLeadExportData();
    const dataSheet = [description, headers, ...data];

    try {
      const response = await jwtFetch(config.ENDPOINT + 'export/report', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          userKeyId: crmUser.user_keyid,
          userEmail: crmUser.email_address,
          data: dataSheet,
          type: 'Lead',
        }),
      });
      const result = await response.json();
      window.open(result.data.url, '_blank');
    } catch (error) {
      console.error('Error uploading report:', error);
    }
  }

  return (
    <div id="report">
      <div className="container-fluid p-0">
        <div className="row g-0 mh-100vh">
          <div className="col-md-2 border-end">
            <div className="d-md-flex d-none align-items-center justify-content-center p-1 h-48">
              <a className="h-100" href="/dashboard"><img className="h-100" src="/cuancuan.png" alt="PointStar" /></a>
            </div>
            <hr className="m-0" />
            <Menu active="report" />
          </div>
          <div className="col-md-10">
            <Header />
            <hr className="m-0" />
            <div className="main">
              <div className="p-4">

                <section className={"mb-4 " + (isGenerated ? 'd-none' : '')}>
                  <div className="d-flex align-items-center justify-content-between mb-4">
                    <div className="fs-24">Generate Report</div>
                  </div>
                  <div className="row mb-4">
                    <div className="col-md-8">
                      <form className="bg-white border-radius-4 p-4" onSubmit={(e) => generateReport(e)}>
                        <div className="border border-1 border-radius-3 p-4 mb-3">
                          {optionsReportType.length > 0 && (
                            <div className="row form-group align-items-center mb-2">
                              <div className="col-md-4">
                                <label>Report Type</label>
                              </div>
                              <div className="col-md-8">
                                <Select options={filteredOptionsReportType} value={filterReportType} onChange={(e) => setFilterReportType(e)} />
                              </div>
                            </div>
                          )}
                          {filterReportType.value === 'Sales' && (
                            <div>
                              <div className="row form-group align-items-center mb-2">
                                <div className="col-md-4">
                                  <label>Created Date</label>
                                </div>
                                <div className="col-md-4">
                                  <input className="form-control" type="date" value={filterCreatedDateStart} onChange={(e) => setFilterCreatedDateStart(e.target.value)} required />
                                </div>
                                <div className="col-md-4">
                                  <input className="form-control" type="date" value={filterCreatedDateEnd} onChange={(e) => setFilterCreatedDateEnd(e.target.value)} required />
                                </div>
                              </div>
                              {optionsQuotationStatus.length > 0 && (
                                <div className="row form-group align-items-center mb-2">
                                  <div className="col-md-4">
                                    <label>Status</label>
                                  </div>
                                  <div className="col-md-8">
                                    <Select options={optionsQuotationStatus} value={filterQuotationStatus} onChange={(e) => setFilterQuotationStatus(e)} isMulti />
                                  </div>
                                </div>
                              )}
                              {optionsSalesName.length > 0 && (
                                <div className="row form-group align-items-center mb-2">
                                  <div className="col-md-4">
                                    <label>Salesperson</label>
                                  </div>
                                  <div className="col-md-8">
                                    <Select
                                      styles={{
                                        option: (provided, state) => ({
                                          ...provided,
                                          color: state.data.status === 'Inactive' ? 'red' : 'black',
                                        }),
                                      }}
                                      options={optionsSalesName}
                                      value={filterSalesName}
                                      onChange={(e) => setFilterSalesName(e)}
                                      isMulti
                                    />
                                  </div>
                                </div>
                              )}
                              {optionsCompanyName.length > 0 && (
                                <div className="row form-group align-items-center mb-2">
                                  <div className="col-md-4">
                                    <label>Company Group</label>
                                  </div>
                                  <div className="col-md-8">
                                    <Select
                                      styles={{
                                        option: (provided, state) => ({
                                          ...provided,
                                          color: state.data.status === 'Inactive' ? 'red' : 'black',
                                        }),
                                      }}
                                      options={optionsCompanyName}
                                      value={filterCompanyName}
                                      onChange={(e) => setFilterCompanyName(e)}
                                      isMulti
                                    />
                                  </div>
                                </div>
                              )}
                              <div className="d-flex justify-content-end">
                                <button className="btn bg-gold ms-2" type="submit" disabled={!quotationReport.length || isLoading}>{!quotationReport.length || isLoading ? 'Loading...' : 'Generate'}</button>
                              </div>
                            </div>
                          )}
                          {filterReportType.value === 'Invoice' && (
                            <div>
                              <div className="row form-group align-items-center mb-2">
                                <div className="col-md-4">
                                  <label>Created Date</label>
                                </div>
                                <div className="col-md-4">
                                  <input className="form-control" type="date" value={filterCreatedDateStart} onChange={(e) => setFilterCreatedDateStart(e.target.value)} required />
                                </div>
                                <div className="col-md-4">
                                  <input className="form-control" type="date" value={filterCreatedDateEnd} onChange={(e) => setFilterCreatedDateEnd(e.target.value)} required />
                                </div>
                              </div>
                              {optionsIouStatus.length > 0 && (
                                <div className="row form-group align-items-center mb-2">
                                  <div className="col-md-4">
                                    <label>Status</label>
                                  </div>
                                  <div className="col-md-8">
                                    <Select options={optionsIouStatus} value={filterIouStatus} onChange={(e) => setFilterIouStatus(e)} isMulti />
                                  </div>
                                </div>
                              )}
                              {optionsSalesName.length > 0 && (
                                <div className="row form-group align-items-center mb-2">
                                  <div className="col-md-4">
                                    <label>Salesperson</label>
                                  </div>
                                  <div className="col-md-8">
                                    <Select
                                      styles={{
                                        option: (provided, state) => ({
                                          ...provided,
                                          color: state.data.status === 'Inactive' ? 'red' : 'black',
                                        }),
                                      }}
                                      options={optionsSalesName}
                                      value={filterSalesName}
                                      onChange={(e) => setFilterSalesName(e)}
                                      isMulti
                                    />
                                  </div>
                                </div>
                              )}
                              {optionsCompanyName.length > 0 && (
                                <div className="row form-group align-items-center mb-2">
                                  <div className="col-md-4">
                                    <label>Company Group</label>
                                  </div>
                                  <div className="col-md-8">
                                    <Select
                                      styles={{
                                        option: (provided, state) => ({
                                          ...provided,
                                          color: state.data.status === 'Inactive' ? 'red' : 'black',
                                        }),
                                      }}
                                      options={optionsCompanyName}
                                      value={filterCompanyName}
                                      onChange={(e) => setFilterCompanyName(e)}
                                      isMulti
                                    />
                                  </div>
                                </div>
                              )}
                              <div className="d-flex justify-content-end">
                                <button className="btn bg-gold ms-2" type="submit" disabled={isLoading}>{isLoading ? 'Loading...' : 'Generate'}</button>
                              </div>
                            </div>
                          )}
                          {filterReportType.value === 'Opportunity' && (
                            <div>
                              <div className="row form-group align-items-center mb-2">
                                <div className="col-md-4">
                                  <label>Created Date</label>
                                </div>
                                <div className="col-md-4">
                                  <input className="form-control" type="date" value={filterCreatedDateStart} onChange={(e) => setFilterCreatedDateStart(e.target.value)} required />
                                </div>
                                <div className="col-md-4">
                                  <input className="form-control" type="date" value={filterCreatedDateEnd} onChange={(e) => setFilterCreatedDateEnd(e.target.value)} required />
                                </div>
                              </div>
                              {optionsOpportunityStatus.length > 0 && (
                                <div className="row form-group align-items-center mb-2">
                                  <div className="col-md-4">
                                    <label>Status</label>
                                  </div>
                                  <div className="col-md-8">
                                    <Select options={optionsOpportunityStatus} value={filterOpportunityStatus} onChange={(e) => setFilterOpportunityStatus(e)} isMulti />
                                  </div>
                                </div>
                              )}
                              {optionsSalesName.length > 0 && (
                                <div className="row form-group align-items-center mb-2">
                                  <div className="col-md-4">
                                    <label>Salesperson</label>
                                  </div>
                                  <div className="col-md-8">
                                    <Select
                                      styles={{
                                        option: (provided, state) => ({
                                          ...provided,
                                          color: state.data.status === 'Inactive' ? 'red' : 'black',
                                        }),
                                      }}
                                      options={optionsSalesName}
                                      value={filterSalesName}
                                      onChange={(e) => setFilterSalesName(e)}
                                      isMulti
                                    />
                                  </div>
                                </div>
                              )}
                              {optionsCompanyName.length > 0 && (
                                <div className="row form-group align-items-center mb-2">
                                  <div className="col-md-4">
                                    <label>Company Group</label>
                                  </div>
                                  <div className="col-md-8">
                                    <Select
                                      styles={{
                                        option: (provided, state) => ({
                                          ...provided,
                                          color: state.data.status === 'Inactive' ? 'red' : 'black',
                                        }),
                                      }}
                                      options={optionsCompanyName}
                                      value={filterCompanyName}
                                      onChange={(e) => setFilterCompanyName(e)}
                                      isMulti
                                    />
                                  </div>
                                </div>
                              )}
                              <div className="d-flex justify-content-end">
                                <button className="btn bg-gold ms-2" type="submit" disabled={isLoading}>{isLoading ? 'Loading...' : 'Generate'}</button>
                              </div>
                            </div>
                          )}
                          {filterReportType.value === 'Lead' && (
                            <div>
                              <div className="row form-group align-items-center mb-2">
                                <div className="col-md-4">
                                  <label>Created Date</label>
                                </div>
                                <div className="col-md-4">
                                  <input className="form-control" type="date" value={filterCreatedDateStart} onChange={(e) => setFilterCreatedDateStart(e.target.value)} required />
                                </div>
                                <div className="col-md-4">
                                  <input className="form-control" type="date" value={filterCreatedDateEnd} onChange={(e) => setFilterCreatedDateEnd(e.target.value)} required />
                                </div>
                              </div>
                              {optionsLeadStatus.length > 0 && (
                                <div className="row form-group align-items-center mb-2">
                                  <div className="col-md-4">
                                    <label>Status</label>
                                  </div>
                                  <div className="col-md-8">
                                    <Select options={optionsLeadStatus} value={filterLeadStatus} onChange={(e) => setFilterLeadStatus(e)} isMulti />
                                  </div>
                                </div>
                              )}
                              {optionsSalesName.length > 0 && (
                                <div className="row form-group align-items-center mb-2">
                                  <div className="col-md-4">
                                    <label>Salesperson</label>
                                  </div>
                                  <div className="col-md-8">
                                    <Select
                                      styles={{
                                        option: (provided, state) => ({
                                          ...provided,
                                          color: state.data.status === 'Inactive' ? 'red' : 'black',
                                        }),
                                      }}
                                      options={optionsSalesName}
                                      value={filterSalesName}
                                      onChange={(e) => setFilterSalesName(e)}
                                      isMulti
                                    />
                                  </div>
                                </div>
                              )}
                              {optionsCompanyName.length > 0 && (
                                <div className="row form-group align-items-center mb-2">
                                  <div className="col-md-4">
                                    <label>Company Group</label>
                                  </div>
                                  <div className="col-md-8">
                                    <Select
                                      styles={{
                                        option: (provided, state) => ({
                                          ...provided,
                                          color: state.data.status === 'Inactive' ? 'red' : 'black',
                                        }),
                                      }}
                                      options={optionsCompanyName}
                                      value={filterCompanyName}
                                      onChange={(e) => setFilterCompanyName(e)}
                                      isMulti
                                    />
                                  </div>
                                </div>
                              )}
                              <div className="d-flex justify-content-end">
                                <button className="btn bg-gold ms-2" type="submit" disabled={isLoading}>{isLoading ? 'Loading...' : 'Generate'}</button>
                              </div>
                            </div>
                          )}
                        </div>
                      </form>
                    </div>
                  </div>
                </section>

                <section className={isGenerated ? '' : 'd-none'}>
                  <div className="d-flex align-items-center justify-content-between mb-3">
                    <div className="d-flex align-items-center justify-content-between gap-4">
                      <div className="fs-24">
                        <button className="btn btn-link" onClick={() => setIsGenerated(false)}>
                          <i className="bi bi-arrow-left" />
                        </button>
                        {filterReportType?.value
                          ? (filterReportType.value === 'Lead'
                            ? 'Leads'
                            : filterReportType.value.charAt(0).toUpperCase() + filterReportType.value.slice(1).toLowerCase())
                          : ''} Report
                      </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-between gap-2">
                      {/*
                      <button className="btn btn-link bg-gold" type="button" onClick={() => setPromptModal(true)}><i className="bi bi-stars me-1" disabled={isLoading}/> Ask Gemini</button>
                      */}
                      <Dropdown>
                        <Dropdown.Toggle className="btn btn-link bg-gold" disabled={isLoading}><i className="bi bi-download me-1" />Export</Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item
                            href="#google-sheet"
                            onClick={() => {
                              if (!filterReportType) return;
                              if (filterReportType.value === 'Sales') {
                                generateSalesSheet();
                              } else if (filterReportType.value === 'Invoice') {
                                generateInvoiceSheet();
                              } else if (filterReportType.value === 'Opportunity') {
                                generateOpportunitySheet();
                              } else if (filterReportType.value === 'Lead') {
                                generateLeadSheet();
                              }
                            }}
                          >
                            Google Sheet
                          </Dropdown.Item>
                          <Dropdown.Item
                            href="#excel-xlsx"
                            onClick={() => {
                              if (!filterReportType) return;
                              if (filterReportType.value === 'Sales') {
                                generateSalesXls();
                              } else if (filterReportType.value === 'Invoice') {
                                generateInvoiceXls();
                              } else if (filterReportType.value === 'Opportunity') {
                                generateOpportunityXls();
                              } else if (filterReportType.value === 'Lead') {
                                generateLeadXls();
                              }
                            }}
                          >
                            Excel XLSX
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </div>
                  <div className="bg-white border-radius-4 p-4">
                    {filterReportType && tableData && tableData.length > 0 && (
                      <div>
                        {isSalesReport && (
                          <div className="row g-3 mb-3">
                            <div className="col-md-6 col-sm-12">
                              <div className="border-radius-4 bg-light p-3 h-100">
                                <div className="text-secondary fs-12">Date Range</div>
                                <div className="fs-20 fw-bold">{`${format(new Date(filterCreatedDateStart), 'd MMM yyyy')} - ${format(new Date(filterCreatedDateEnd), 'd MMM yyyy')}`}</div>
                              </div>
                            </div>
                            <div className="col-md-3 col-sm-6">
                              <div className="border-radius-4 bg-light p-3 h-100">
                                <div className="text-secondary fs-12">Total Created Quotations</div>
                                <div className="fs-20 fw-bold">{totalQuotations}</div>
                              </div>
                            </div>
                            <div className="col-md-3 col-sm-6">
                              <div className="border-radius-4 bg-light p-3 h-100">
                                <div className="text-secondary fs-12">Total Sold Items</div>
                                <div className="fs-20 fw-bold">{totalSoldItems}</div>
                              </div>
                            </div>
                            <div className="col-md-3 col-sm-6">
                              <div className="border-radius-4 bg-light p-3 h-100">
                                <div className="text-secondary fs-12">Gross Revenue (IDR)</div>
                                <div className="fs-20 fw-bold">{priceFormat(grossSales)}</div>
                              </div>
                            </div>
                            <div className="col-md-3 col-sm-6">
                              <div className="border-radius-4 bg-light p-3 h-100">
                                <div className="text-secondary fs-12">Gross Profit (IDR)</div>
                                <div className="fs-20 fw-bold">{priceFormat(grossProfit)}</div>
                              </div>
                            </div>
                            <div className="col-md-3 col-sm-6">
                              <div className="border-radius-4 bg-light p-3 h-100">
                                <div className="text-secondary fs-12">Quotation Win Rate</div>
                                <div className="fs-20 fw-bold">{priceFormat(quotationWinRate, '%')}</div>
                              </div>
                            </div>
                            <div className="col-md-3 col-sm-6">
                              <div className="border-radius-4 bg-light p-3 h-100">
                                <div className="text-secondary fs-12">Average Profit Percentage</div>
                                <div className="fs-20 fw-bold">{priceFormat(avgProfitPercent, '%')}</div>
                              </div>
                            </div>
                          </div>
                        )}
                        {isInvoiceReport && (
                          <div className="row g-3 mb-3">
                            <div className="col-md-6 col-sm-12">
                              <div className="border-radius-4 bg-light p-3 h-100">
                                <div className="text-secondary fs-12">Date Range</div>
                                <div className="fs-20 fw-bold">{`${format(new Date(filterCreatedDateStart), 'd MMM yyyy')} - ${format(new Date(filterCreatedDateEnd), 'd MMM yyyy')}`}</div>
                              </div>
                            </div>
                            <div className="col-md-3 col-sm-6">
                              <div className="border-radius-4 bg-light p-3 h-100">
                                <div className="text-secondary fs-12">Total Created Quotations</div>
                                <div className="fs-20 fw-bold">{totalQuotations}</div>
                              </div>
                            </div>
                            <div className="col-md-3 col-sm-6">
                              <div className="border-radius-4 bg-light p-3 h-100">
                                <div className="text-secondary fs-12">Total Paid Invoices</div>
                                <div className="fs-20 fw-bold">{totalSoldItems}</div>
                              </div>
                            </div>
                            <div className="col-md-3 col-sm-6">
                              <div className="border-radius-4 bg-light p-3 h-100">
                                <div className="text-secondary fs-12">Gross Revenue (IDR)</div>
                                <div className="fs-20 fw-bold">{priceFormat(grossSales)}</div>
                              </div>
                            </div>
                            <div className="col-md-3 col-sm-6">
                              <div className="border-radius-4 bg-light p-3 h-100">
                                <div className="text-secondary fs-12">Gross Profit (IDR)</div>
                                <div className="fs-20 fw-bold">{priceFormat(grossProfit)}</div>
                              </div>
                            </div>
                            <div className="col-md-3 col-sm-6">
                              <div className="border-radius-4 bg-light p-3 h-100">
                                <div className="text-secondary fs-12">Quotation Win Rate</div>
                                <div className="fs-20 fw-bold">{priceFormat(quotationWinRate, '%')}</div>
                              </div>
                            </div>
                            <div className="col-md-3 col-sm-6">
                              <div className="border-radius-4 bg-light p-3 h-100">
                                <div className="text-secondary fs-12">Average Profit Percentage</div>
                                <div className="fs-20 fw-bold">{priceFormat(avgProfitPercent, '%')}</div>
                              </div>
                            </div>
                          </div>
                        )}
                        {isOpportunityReport && (
                          <div className="row g-3 mb-3">
                            <div className="col-md-6 col-sm-12">
                              <div className="border-radius-4 bg-light p-3 h-100">
                                <div className="text-secondary fs-12">Date Range</div>
                                <div className="fs-20 fw-bold">{`${format(new Date(filterCreatedDateStart), 'd MMM yyyy')} - ${format(new Date(filterCreatedDateEnd), 'd MMM yyyy')}`}</div>
                              </div>
                            </div>
                            <div className="col-md-3 col-sm-6">
                              <div className="border-radius-4 bg-light p-3 h-100">
                                <div className="text-secondary fs-12">Total Created Opportunities</div>
                                <div className="fs-20 fw-bold">{totalOpportunities}</div>
                              </div>
                            </div>
                            <div className="col-md-3 col-sm-6">
                              <div className="border-radius-4 bg-light p-3 h-100">
                                <div className="text-secondary fs-12">Total Won Opportunities</div>
                                <div className="fs-20 fw-bold">{totalWonOpportunities}</div>
                              </div>
                            </div>
                            <div className="col-md-3 col-sm-6">
                              <div className="border-radius-4 bg-light p-3 h-100">
                                <div className="text-secondary fs-12">Total Estimated Revenue (IDR)</div>
                                <div className="fs-20 fw-bold">{priceFormat(totalEstimatedRevenue)}</div>
                              </div>
                            </div>
                            <div className="col-md-3 col-sm-6">
                              <div className="border-radius-4 bg-light p-3 h-100">
                                <div className="text-secondary fs-12">Total Estimated Profit (IDR)</div>
                                <div className="fs-20 fw-bold">{priceFormat(totalEstimatedProfit)}</div>
                              </div>
                            </div>
                            <div className="col-md-3 col-sm-6">
                              <div className="border-radius-4 bg-light p-3 h-100">
                                <div className="text-secondary fs-12">Total Quotation Revenue (IDR)</div>
                                <div className="fs-20 fw-bold">{priceFormat(totalQuotationRevenue)}</div>
                              </div>
                            </div>
                            <div className="col-md-3 col-sm-6">
                              <div className="border-radius-4 bg-light p-3 h-100">
                                <div className="text-secondary fs-12">Total Quotation Profit (IDR)</div>
                                <div className="fs-20 fw-bold">{priceFormat(totalQuotationProfit)}</div>
                              </div>
                            </div>
                          </div>
                        )}
                        {isLeadReport && (
                          <div className="row g-3 mb-3">
                            <div className="col-md-6 col-sm-12">
                              <div className="border-radius-4 bg-light p-3 h-100">
                                <div className="text-secondary fs-12">Date Range</div>
                                <div className="fs-20 fw-bold">{`${format(new Date(filterCreatedDateStart), 'd MMM yyyy')} - ${format(new Date(filterCreatedDateEnd), 'd MMM yyyy')}`}</div>
                              </div>
                            </div>
                            <div className="col-md-3 col-sm-6">
                              <div className="border-radius-4 bg-light p-3 h-100">
                                <div className="text-secondary fs-12">Total Created Leads</div>
                                <div className="fs-20 fw-bold">{totalLeads}</div>
                              </div>
                            </div>
                            <div className="col-md-3 col-sm-6">
                              <div className="border-radius-4 bg-light p-3 h-100">
                                <div className="text-secondary fs-12">Leads Converted to Won</div>
                                <div className="fs-20 fw-bold">{totalWonLeads}</div>
                              </div>
                            </div>
                            <div className="col-md-3 col-sm-6">
                              <div className="border-radius-4 bg-light p-3 h-100">
                                <div className="text-secondary fs-12">Total Qualified Leads</div>
                                <div className="fs-20 fw-bold">{totalQualifiedLeads}</div>
                              </div>
                            </div>
                            <div className="col-md-3 col-sm-6">
                              <div className="border-radius-4 bg-light p-3 h-100">
                                <div className="text-secondary fs-12">Total Leads with Opportunities</div>
                                <div className="fs-20 fw-bold">{totalLeadsWithOpportunities}</div>
                              </div>
                            </div>
                            <div className="col-md-3 col-sm-6">
                              <div className="border-radius-4 bg-light p-3 h-100">
                                <div className="text-secondary fs-12">Total Quotation Revenue (IDR)</div>
                                <div className="fs-20 fw-bold">{priceFormat(totalLeadQuotationRevenue)}</div>
                              </div>
                            </div>
                            <div className="col-md-3 col-sm-6">
                              <div className="border-radius-4 bg-light p-3 h-100">
                                <div className="text-secondary fs-12">Total Quotation Profit (IDR)</div>
                                <div className="fs-20 fw-bold">{priceFormat(totalLeadQuotationProfit)}</div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                    <div className="table-responsive mb-2" style={{ maxHeight: 'calc(100vh - 230px)', overflow: 'auto' }}>
                      {isLoading ? (
                        <p>{isLoading ? 'Loading...' : 'No data'}</p>
                      ) : (
                        filterReportType && (
                          <div>
                            {filterReportType.value === 'Sales' && (
                              <table id="table-data" className="table table-hover mb-0" style={{ tableLayout: 'auto', width: '100%' }}>
                                <thead style={{ position: 'sticky', top: 0, zIndex: 3 }}>
                                  <tr>
                                    <th className="bg-gold text-nowrap w-40">#</th>
                                    <th className="bg-gold text-nowrap">QT_Number</th>
                                    <th className="bg-gold text-nowrap">Status</th>
                                    <th className="bg-gold text-nowrap">Is_Invoicing_Only?</th>
                                    <th className="bg-gold text-nowrap">Company_Group</th>
                                    <th className="bg-gold text-nowrap">Subsidiary</th>
                                    <th className="bg-gold text-nowrap">Salesperson</th>
                                    <th className="bg-gold text-nowrap">Created_Date</th>
                                    <th className="bg-gold text-nowrap">Effective_Date</th>
                                    <th className="bg-gold text-nowrap">Expiry_Date</th>
                                    <th className="bg-gold text-nowrap">Won_Date</th>
                                    <th className="bg-gold text-nowrap">SO_Number</th>
                                    <th className="bg-gold text-nowrap">SO_Status</th>
                                    <th className="bg-gold text-nowrap">INVREQ_Number</th>
                                    <th className="bg-gold text-nowrap">INVREQ_Status</th>
                                    <th className="bg-gold text-nowrap">Invoice_Number</th>
                                    <th className="bg-gold text-nowrap">QT_Currency</th>
                                    <th className="bg-gold text-nowrap">FX_Base_Currency</th>
                                    <th className="bg-gold text-nowrap">FX_Rate_to_IDR</th>
                                    <th className="bg-gold text-nowrap">FX_Type</th>
                                    <th className="bg-gold text-nowrap">Order_Type</th>
                                    <th className="bg-gold text-nowrap">Is_Upgrade?</th>
                                    <th className="bg-gold text-nowrap">Product_Type</th>
                                    <th className="bg-gold text-nowrap">Product_Tagging</th>
                                    <th className="bg-gold text-nowrap">Domain_Provisioning</th>
                                    <th className="bg-gold text-nowrap">SKU</th>
                                    <th className="bg-gold text-nowrap">Quantity</th>
                                    <th className="bg-gold text-nowrap">Contract_Length_Months</th>
                                    <th className="bg-gold text-nowrap">Cost_Currency</th>
                                    <th className="bg-gold text-nowrap">Cost_Unit_Original</th>
                                    <th className="bg-gold text-nowrap">Cost_Unit_IDR</th>
                                    <th className="bg-gold text-nowrap">Sell_Currency</th>
                                    <th className="bg-gold text-nowrap">Sell_Unit_Original</th>
                                    <th className="bg-gold text-nowrap">Sell_Unit_IDR</th>
                                    <th className="bg-gold text-nowrap">Item_Subtotal_IDR</th>
                                    <th className="bg-gold text-nowrap">Item_Discount_Amount_IDR</th>
                                    <th className="bg-gold text-nowrap">Item_Discount_Percent</th>
                                    <th className="bg-gold text-nowrap">Item_GrandTotal_IDR</th>
                                    <th className="bg-gold text-nowrap">Item_Margin_IDR</th>
                                    <th className="bg-gold text-nowrap">Item_Margin_Percent</th>
                                    <th className="bg-gold text-nowrap">QT_Subtotal_IDR</th>
                                    <th className="bg-gold text-nowrap">QT_Discount_Amount_IDR</th>
                                    <th className="bg-gold text-nowrap">QT_Discount_Percent</th>
                                    <th className="bg-gold text-nowrap">QT_GrandTotal_IDR</th>
                                    <th className="bg-gold text-nowrap">QT_Profit_IDR</th>
                                    <th className="bg-gold text-nowrap">QT_Profit_Percent</th>
                                    <th className="bg-gold text-nowrap">Payment_Type</th>
                                    <th className="bg-gold text-nowrap">Period_Start_Date</th>
                                    <th className="bg-gold text-nowrap">Period_End_Date</th>
                                    <th className="bg-gold text-nowrap">Helper_QT_Subtotal_IDR</th>
                                    <th className="bg-gold text-nowrap">Helper_QT_Discount_IDR</th>
                                    <th className="bg-gold text-nowrap">Helper_QT_GrandTotal_IDR</th>
                                    <th className="bg-gold text-nowrap">Helper_QT_Profit_IDR</th>
                                    <th className="bg-gold text-nowrap">Helper_Canceled_IDR</th>
                                    <th className="bg-gold text-nowrap">Helper_Actual_IDR</th>
                                    <th className="bg-gold text-nowrap">Helper_QT_Count</th>
                                    <th className="bg-gold text-nowrap">Renewal_Flag</th>
                                    <th className="bg-gold text-nowrap">Year</th>
                                    <th className="bg-gold text-nowrap">Month</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {tableData.map((rowData, r) =>
                                    <tr key={"data-" + r}>
                                      <td className="text-nowrap">{r + 1}</td>
                                      <td className="text-nowrap">{rowData.quotation_code}</td>
                                      <td className="text-nowrap">{rowData.status}</td>
                                      <td className="text-nowrap">{rowData.is_invoicing_only ? 'Yes' : 'No'}</td>
                                      <td className="text-nowrap">{rowData.company_name}</td>
                                      <td className="text-nowrap">{rowData.subcompany_name}</td>
                                      <td className="text-nowrap">{rowData.sales_name}</td>
                                      <td className="text-nowrap">{format(rowData.created_date, 'd MMM yyyy')}</td>
                                      <td className="text-nowrap">{format(rowData.effective_date, 'd MMM yyyy')}</td>
                                      <td className="text-nowrap">{format(rowData.expiry_date, 'd MMM yyyy')}</td>
                                      <td className="text-nowrap">{rowData.won_date ? format(rowData.won_date, 'd MMM yyyy') : ''}</td>
                                      <td className="text-nowrap">{rowData.so_code}</td>
                                      <td className="text-nowrap">{rowData.so_status}</td>
                                      <td className="text-nowrap">{rowData.iou_code_first}</td>
                                      <td className="text-nowrap">{rowData.iou_status_first}</td>
                                      <td className="text-nowrap">{rowData.invoice_number_first}</td>
                                      <td className="text-nowrap">{rowData.currency}</td>
                                      <td className="text-nowrap">{rowData.original_currency}</td>
                                      <td className="text-nowrap text-end">{priceFormat(rowData.exchange_rate)}</td>
                                      <td className="text-nowrap">{rowData.exchange_type}</td>
                                      <td className="text-nowrap">{rowData.order_type}</td>
                                      <td className="text-nowrap">{rowData.is_upgrade ? 'Yes' : 'No'}</td>
                                      <td className="text-nowrap">{rowData.product_type}</td>
                                      <td className="text-nowrap">{rowData.product_tagging}</td>
                                      <td className="text-nowrap">{rowData.product_domain}</td>
                                      <td className="text-nowrap">{rowData.sku}</td>
                                      <td className="text-nowrap text-end">{priceFormat(rowData.quantity)}</td>
                                      <td className="text-nowrap text-end">{priceFormat(rowData.period)}</td>
                                      <td className="text-nowrap">{rowData.original_currency}</td>
                                      <td className="text-nowrap text-end">{priceFormat(rowData.original_cost_price)}</td>
                                      <td className="text-nowrap text-end">{priceFormat(rowData.cost_price)}</td>
                                      <td className="text-nowrap">{rowData.original_currency}</td>
                                      <td className="text-nowrap text-end">{priceFormat(rowData.original_selling_price)}</td>
                                      <td className="text-nowrap text-end">{priceFormat(rowData.selling_price)}</td>
                                      <td className="text-nowrap text-end">{priceFormat(rowData.item_subtotal)}</td>
                                      <td className="text-nowrap text-end">{priceFormat(rowData.item_discount)}</td>
                                      <td className="text-nowrap text-end">{priceFormat(rowData.item_discount_percentage, '%')}</td>
                                      <td className="text-nowrap text-end">{priceFormat(rowData.item_grand_total)}</td>
                                      <td className="text-nowrap text-end">{priceFormat(rowData.item_margin)}</td>
                                      <td className="text-nowrap text-end">{priceFormat(rowData.item_margin_percentage, '%')}</td>
                                      <td className="text-nowrap text-end">{priceFormat(rowData.quotation_subtotal)}</td>
                                      <td className="text-nowrap text-end">{priceFormat(rowData.quotation_discount)}</td>
                                      <td className="text-nowrap text-end">{priceFormat(rowData.quotation_discount_percentage, '%')}</td>
                                      <td className="text-nowrap text-end">{priceFormat(rowData.quotation_grand_total)}</td>
                                      <td className="text-nowrap text-end">{priceFormat(rowData.quotation_margin)}</td>
                                      <td className="text-nowrap text-end">{priceFormat(rowData.quotation_margin_percentage, '%')}</td>
                                      <td className="text-nowrap">{rowData.payment_type}</td>
                                      <td className="text-nowrap">{rowData.iou_start_date ? format(rowData.iou_start_date, 'd MMM yyyy') : (rowData.start_date ? format(rowData.start_date, 'd MMM yyyy') : '')}</td>
                                      <td className="text-nowrap">{rowData.iou_end_date ? format(rowData.iou_end_date, 'd MMM yyyy') : (rowData.end_date ? format(rowData.end_date, 'd MMM yyyy') : '')}</td>
                                      <td className="text-nowrap text-end">{r === 0 || rowData.quotation_code !== tableData[r - 1].quotation_code ? priceFormat(rowData.quotation_subtotal) : ''}</td>
                                      <td className="text-nowrap text-end">{r === 0 || rowData.quotation_code !== tableData[r - 1].quotation_code ? priceFormat(rowData.quotation_discount) : ''}</td>
                                      <td className="text-nowrap text-end">{r === 0 || rowData.quotation_code !== tableData[r - 1].quotation_code ? priceFormat(rowData.quotation_grand_total) : ''}</td>
                                      <td className="text-nowrap text-end">{r === 0 || rowData.quotation_code !== tableData[r - 1].quotation_code ? priceFormat(rowData.quotation_margin) : ''}</td>
                                      <td className="text-nowrap text-end">{r === 0 || rowData.quotation_code !== tableData[r - 1].quotation_code ? priceFormat(rowData.iou_canceled) : ''}</td>
                                      <td className="text-nowrap text-end">{r === 0 || rowData.quotation_code !== tableData[r - 1].quotation_code ? priceFormat(rowData.iou_total) : ''}</td>
                                      <td className="text-nowrap text-end">{r === 0 || rowData.quotation_code !== tableData[r - 1].quotation_code ? 1 : 0}</td>
                                      <td className="text-nowrap text-end">{rowData.order_type === 'Renewal' ? 1 : 0}</td>
                                      <td className="text-nowrap">{rowData.quotation_year}</td>
                                      <td className="text-nowrap">{rowData.quotation_year_month}</td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            )}
                            {filterReportType.value === 'Invoice' && (
                              <table id="table-data" className="table table-hover mb-0" style={{ tableLayout: 'auto', width: '100%' }}>
                                <thead style={{ position: 'sticky', top: 0, zIndex: 3 }}>
                                  <tr>
                                    <th className="bg-gold text-nowrap w-40">#</th>
                                    <th className="bg-gold text-nowrap">QT_Number</th>
                                    <th className="bg-gold text-nowrap">Status</th>
                                    <th className="bg-gold text-nowrap">Is_Invoicing_Only?</th>
                                    <th className="bg-gold text-nowrap">Company_Group</th>
                                    <th className="bg-gold text-nowrap">Subsidiary</th>
                                    <th className="bg-gold text-nowrap">Salesperson</th>
                                    <th className="bg-gold text-nowrap">Created_Date</th>
                                    <th className="bg-gold text-nowrap">Effective_Date</th>
                                    <th className="bg-gold text-nowrap">Expiry_Date</th>
                                    <th className="bg-gold text-nowrap">Won_Date</th>
                                    <th className="bg-gold text-nowrap">QT_Currency</th>
                                    <th className="bg-gold text-nowrap">FX_Base_Currency</th>
                                    <th className="bg-gold text-nowrap">FX_Rate_to_IDR</th>
                                    <th className="bg-gold text-nowrap">FX_Type</th>
                                    <th className="bg-gold text-nowrap">QT_Subtotal_IDR</th>
                                    <th className="bg-gold text-nowrap">QT_Discount_Amount_IDR</th>
                                    <th className="bg-gold text-nowrap">QT_Discount_Percent</th>
                                    <th className="bg-gold text-nowrap">QT_GrandTotal_IDR</th>
                                    <th className="bg-gold text-nowrap">QT_Profit_IDR</th>
                                    <th className="bg-gold text-nowrap">QT_Profit_Percent</th>
                                    <th className="bg-gold text-nowrap">Payment_Type</th>
                                    <th className="bg-gold text-nowrap">Period_Start_Date</th>
                                    <th className="bg-gold text-nowrap">Period_End_Date</th>
                                    <th className="bg-gold text-nowrap">Sales_Order_Number</th>
                                    <th className="bg-gold text-nowrap">Sales_Order_Status</th>
                                    <th className="bg-gold text-nowrap">Schedule_Number</th>
                                    <th className="bg-gold text-nowrap">Schedule_Start_Date</th>
                                    <th className="bg-gold text-nowrap">Schedule_End_Date</th>
                                    <th className="bg-gold text-nowrap">Invoice_Request_Amount_IDR</th>
                                    <th className="bg-gold text-nowrap">Invoice_Request_Status</th>
                                    <th className="bg-gold text-nowrap">Invoice_Request_Code</th>
                                    <th className="bg-gold text-nowrap">Invoice_Number</th>
                                    <th className="bg-gold text-nowrap">Invoice_Amount_IDR</th>
                                    <th className="bg-gold text-nowrap">Helper_QT_Subtotal_IDR</th>
                                    <th className="bg-gold text-nowrap">Helper_QT_Discount_IDR</th>
                                    <th className="bg-gold text-nowrap">Helper_QT_GrandTotal_IDR</th>
                                    <th className="bg-gold text-nowrap">Helper_QT_Profit_IDR</th>
                                    <th className="bg-gold text-nowrap">Helper_QT_Count</th>
                                    <th className="bg-gold text-nowrap">Year</th>
                                    <th className="bg-gold text-nowrap">Month</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {tableData.map((rowData, r) =>
                                    <tr key={"data-" + r}>
                                      <td className="text-nowrap">{r + 1}</td>
                                      <td className="text-nowrap">{rowData.quotation_code}</td>
                                      <td className="text-nowrap">{rowData.status}</td>
                                      <td className="text-nowrap">{rowData.is_invoicing_only ? 'Yes' : 'No'}</td>
                                      <td className="text-nowrap">{rowData.company_name}</td>
                                      <td className="text-nowrap">{rowData.subcompany_name}</td>
                                      <td className="text-nowrap">{rowData.sales_name}</td>
                                      <td className="text-nowrap">{format(rowData.created_date, 'd MMM yyyy')}</td>
                                      <td className="text-nowrap">{format(rowData.effective_date, 'd MMM yyyy')}</td>
                                      <td className="text-nowrap">{format(rowData.expiry_date, 'd MMM yyyy')}</td>
                                      <td className="text-nowrap">{rowData.won_date ? format(rowData.won_date, 'd MMM yyyy') : ''}</td>
                                      <td className="text-nowrap">{rowData.currency}</td>
                                      <td className="text-nowrap">{rowData.original_currency}</td>
                                      <td className="text-nowrap text-end">{priceFormat(rowData.exchange_rate)}</td>
                                      <td className="text-nowrap">{rowData.exchange_type}</td>
                                      <td className="text-nowrap text-end">{priceFormat(rowData.quotation_subtotal)}</td>
                                      <td className="text-nowrap text-end">{priceFormat(rowData.quotation_discount)}</td>
                                      <td className="text-nowrap text-end">{priceFormat(rowData.quotation_discount_percentage, '%')}</td>
                                      <td className="text-nowrap text-end">{priceFormat(rowData.quotation_grand_total)}</td>
                                      <td className="text-nowrap text-end">{priceFormat(rowData.quotation_margin)}</td>
                                      <td className="text-nowrap text-end">{priceFormat(rowData.quotation_margin_percentage, '%')}</td>
                                      <td className="text-nowrap">{rowData.payment_type}</td>
                                      <td className="text-nowrap">{format(rowData.iou_start_date ? rowData.iou_start_date : rowData.start_date, 'd MMM yyyy')}</td>
                                      <td className="text-nowrap">{format(rowData.iou_end_date ? rowData.iou_end_date : rowData.end_date, 'd MMM yyyy')}</td>
                                      <td className="text-nowrap">{rowData.so_code}</td>
                                      <td className="text-nowrap">{rowData.so_status}</td>
                                      <td className="text-nowrap">{rowData.iou_schedule}</td>
                                      <td className="text-nowrap">{rowData.iou_start_date ? format(rowData.iou_start_date, 'd MMM yyyy') : ''}</td>
                                      <td className="text-nowrap">{rowData.iou_end_date ? format(rowData.iou_end_date, 'd MMM yyyy') : ''}</td>
                                      <td className="text-nowrap text-end">{rowData.iou_grand_total ? priceFormat(rowData.iou_grand_total) : ''}</td>
                                      <td className="text-nowrap">{rowData.iou_status}</td>
                                      <td className="text-nowrap">{rowData.iou_code}</td>
                                      <td className="text-nowrap">{rowData.invoice_number}</td>
                                      <td className="text-nowrap text-end">{rowData.invoice_amount ? priceFormat(rowData.invoice_amount) : ''}</td>
                                      <td className="text-nowrap text-end">{r === 0 || rowData.quotation_code !== tableData[r - 1].quotation_code ? priceFormat(rowData.quotation_subtotal) : ''}</td>
                                      <td className="text-nowrap text-end">{r === 0 || rowData.quotation_code !== tableData[r - 1].quotation_code ? priceFormat(rowData.quotation_discount) : ''}</td>
                                      <td className="text-nowrap text-end">{r === 0 || rowData.quotation_code !== tableData[r - 1].quotation_code ? priceFormat(rowData.quotation_grand_total) : ''}</td>
                                      <td className="text-nowrap text-end">{r === 0 || rowData.quotation_code !== tableData[r - 1].quotation_code ? priceFormat(rowData.quotation_margin) : ''}</td>
                                      <td className="text-nowrap text-end">{r === 0 || rowData.quotation_code !== tableData[r - 1].quotation_code ? 1 : 0}</td>
                                      <td className="text-nowrap">{rowData.quotation_year}</td>
                                      <td className="text-nowrap">{rowData.quotation_year_month}</td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            )}
                            {filterReportType.value === 'Opportunity' && (
                              <table id="table-data" className="table table-hover mb-0" style={{ tableLayout: 'auto', width: '100%' }}>
                                <thead style={{ position: 'sticky', top: 0, zIndex: 3 }}>
                                  <tr>
                                    <th className="bg-gold text-nowrap w-40">#</th>
                                    <th className="bg-gold text-nowrap">Opportunity_Number</th>
                                    <th className="bg-gold text-nowrap">Status</th>
                                    <th className="bg-gold text-nowrap">Company_Group</th>
                                    <th className="bg-gold text-nowrap">Subsidiary</th>
                                    <th className="bg-gold text-nowrap">Salesperson</th>
                                    <th className="bg-gold text-nowrap">Created_Date</th>
                                    <th className="bg-gold text-nowrap">Source</th>
                                    <th className="bg-gold text-nowrap">Product</th>
                                    <th className="bg-gold text-nowrap">Deal_Type</th>
                                    <th className="bg-gold text-nowrap">Months</th>
                                    <th className="bg-gold text-nowrap">Expected_Closing_Date</th>
                                    <th className="bg-gold text-nowrap">Won_Date</th>
                                    <th className="bg-gold text-nowrap">Open_for_Days</th>
                                    <th className="bg-gold text-nowrap">Estimated_Revenue</th>
                                    <th className="bg-gold text-nowrap">Estimated_Profit</th>
                                    <th className="bg-gold text-nowrap">Quotation_Revenue</th>
                                    <th className="bg-gold text-nowrap">Quotation_Profit</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {tableData.map((rowData, r) =>
                                    <tr key={"data-" + r}>
                                      <td className="text-nowrap">{r + 1}</td>
                                      <td className="text-nowrap">{rowData.opportunity_code}</td>
                                      <td className="text-nowrap">{rowData.opportunity_status}</td>
                                      <td className="text-nowrap">{rowData.company_name}</td>
                                      <td className="text-nowrap">{rowData.subcompany_name}</td>
                                      <td className="text-nowrap">{rowData.sales_name}</td>
                                      <td className="text-nowrap">{format(rowData.created_on, 'd MMM yyyy')}</td>
                                      <td className="text-nowrap">{rowData.opportunity_source}</td>
                                      <td className="text-nowrap">{rowData.opportunity_product_line}</td>
                                      <td className="text-nowrap">{rowData.opportunity_deal_type}</td>
                                      <td className="text-nowrap text-end">{rowData.opportunity_product_months}</td>
                                      <td className="text-nowrap">{rowData.opportunity_expected_closed ? format(rowData.opportunity_expected_closed, 'd MMM yyyy') : ''}</td>
                                      <td className="text-nowrap">{rowData.won_date ? format(rowData.won_date, 'd MMM yyyy') : ''}</td>
                                      <td className="text-nowrap text-end">{priceFormat(rowData.open_for)}</td>
                                      <td className="text-nowrap text-end">{priceFormat(rowData.opportunity_expected_revenue)}</td>
                                      <td className="text-nowrap text-end">{priceFormat(rowData.opportunity_expected_profit)}</td>
                                      <td className="text-nowrap text-end">{priceFormat(rowData.quotation_total)}</td>
                                      <td className="text-nowrap text-end">{priceFormat(rowData.quotation_margin_price)}</td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            )}
                            {filterReportType.value === 'Lead' && (
                              <table id="table-data" className="table table-hover mb-0" style={{ tableLayout: 'auto', width: '100%' }}>
                                <thead style={{ position: 'sticky', top: 0, zIndex: 3 }}>
                                  <tr>
                                    <th className="bg-gold text-nowrap w-40">#</th>
                                    <th className="bg-gold text-nowrap">Lead_Number</th>
                                    <th className="bg-gold text-nowrap">Created_Date</th>
                                    <th className="bg-gold text-nowrap">Status</th>
                                    <th className="bg-gold text-nowrap">Company_Group</th>
                                    <th className="bg-gold text-nowrap">Subsidiary</th>
                                    <th className="bg-gold text-nowrap">Contact_Person</th>
                                    <th className="bg-gold text-nowrap">Email_address</th>
                                    <th className="bg-gold text-nowrap">Phone_Number</th>
                                    <th className="bg-gold text-nowrap">Position</th>
                                    <th className="bg-gold text-nowrap">Category</th>
                                    <th className="bg-gold text-nowrap">Product</th>
                                    <th className="bg-gold text-nowrap">DR_Number</th>
                                    <th className="bg-gold text-nowrap">Budget</th>
                                    <th className="bg-gold text-nowrap">Authority</th>
                                    <th className="bg-gold text-nowrap">Need</th>
                                    <th className="bg-gold text-nowrap">Timeline</th>
                                    <th className="bg-gold text-nowrap">Source</th>
                                    <th className="bg-gold text-nowrap">Channel</th>
                                    <th className="bg-gold text-nowrap">Follow_Up</th>
                                    <th className="bg-gold text-nowrap">Marketingperson</th>
                                    <th className="bg-gold text-nowrap">Assigned_to</th>
                                    <th className="bg-gold text-nowrap">Opportunity_Statuses</th>
                                    <th className="bg-gold text-nowrap">Quotation_Statuses</th>
                                    <th className="bg-gold text-nowrap">Won_Date</th>
                                    <th className="bg-gold text-nowrap">Quotation_Revenue</th>
                                    <th className="bg-gold text-nowrap">Quotation_Profit</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {tableData.map((rowData, r) =>
                                    <tr key={"data-" + r}>
                                      <td className="text-nowrap">{r + 1}</td>
                                      <td className="text-nowrap">{rowData.lead_code}</td>
                                      <td className="text-nowrap">{format(rowData.created_on, 'd MMM yyyy')}</td>
                                      <td className="text-nowrap">{rowData.lead_status}</td>
                                      <td className="text-nowrap">{rowData.company_name}</td>
                                      <td className="text-nowrap">{rowData.subcompany_name}</td>
                                      <td className="text-nowrap">{rowData.contact_name}</td>
                                      <td className="text-nowrap">{rowData.contact_email}</td>
                                      <td className="text-nowrap">{rowData.contact_phone}</td>
                                      <td className="text-nowrap">{rowData.contact_position}</td>
                                      <td className="text-nowrap">{rowData.lead_category}</td>
                                      <td className="text-nowrap">{rowData.lead_products}</td>
                                      <td className="text-nowrap">{rowData.lead_dr_number}</td>
                                      <td className="text-nowrap text-end">{priceFormat(rowData.bant_budget)}</td>
                                      <td className="text-nowrap">{rowData.bant_authority}</td>
                                      <td className="text-nowrap">{rowData.bant_need}</td>
                                      <td className="text-nowrap">{rowData.bant_timeline}</td>
                                      <td className="text-nowrap">{rowData.source_name}</td>
                                      <td className="text-nowrap">{rowData.source_channel}</td>
                                      <td className="text-nowrap">{rowData.source_status}</td>
                                      <td className="text-nowrap">{rowData.marketing_name}</td>
                                      <td className="text-nowrap">{rowData.sales_name}</td>
                                      <td className="text-nowrap">{rowData.opportunity_statuses}</td>
                                      <td className="text-nowrap">{rowData.quotation_statuses}</td>
                                      <td className="text-nowrap">{rowData.won_date ? format(rowData.won_date, 'd MMM yyyy') : '-'}</td>
                                      <td className="text-nowrap text-end">{priceFormat(rowData.quotation_total)}</td>
                                      <td className="text-nowrap text-end">{priceFormat(rowData.quotation_margin_price)}</td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            )}
                          </div>
                        )
                      )}
                    </div>
                  </div>
                </section>

              </div>
            </div>
          </div>

          <Modal show={promptModal} onHide={() => closePrompt()} size="lg">
            <Modal.Header closeButton>
              <Modal.Title>Ask Gemini</Modal.Title>
            </Modal.Header>
            {promptResponse ? (
              <Modal.Body>
                <div className="alert alert-light mb-3" role="alert">{promptMessage}</div>
                <div id="printable-prompt">
                  <div className="mb-4" dangerouslySetInnerHTML={{ __html: promptResponse.replace(/```html/g, '').replace(/```/g, '') }} />
                </div>
                <div className="d-flex gap-2">
                  <button className="btn btn-link bg-gold" type="button" onClick={() => printPrompt()}>Export</button>
                  <button className="btn btn-link bg-gold" type="button" onClick={() => clearPrompt()}><i className="bi bi-stars me-1" disabled={isLoading} /> Ask More</button>
                </div>
              </Modal.Body>
            ) : (
              <Modal.Body>
                <form className="w-100" onSubmit={(e) => sendPrompt(e)}>
                  <div className="row align-items-center form-group mb-2">
                    <div className="col-md-10">
                      <input className="form-control" type="text" placeholder="Type your question here" value={promptMessage} onChange={(e) => setPromptMessage(e.target.value)} required />
                    </div>
                    <div className="col-md-2">
                      <button className="btn btn-link bg-gold w-100" type="submit" disabled={promptLoading}>{promptLoading ? "Loading..." : "Send"}</button>
                    </div>
                  </div>
                </form>
              </Modal.Body>
            )}
          </Modal>

        </div>
      </div>
    </div>
  );
};

export default Report;


